import { InputTextAreaForm, InputForm } from 'components/InputForm';
import { useForm, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store/store.inteface';
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect, useState } from 'react';
import { Label, ColInput, RowInput } from '../sharedStyles';
import ButtonContainer from '../components/ButtonContainer';
import { Wrapper } from './styles';
import { schema, schemaDraft } from './schema';
import useModalSaveDraft from '../useModalSaveDraft';
import ModalSaveDraft from '../components/ModalSaveDraft';

export const Step2 = (): JSX.Element => {
  const {
    openModal,
    setOpenModal,
    stateModal,
    setStateModal,
    onClickForward,
    saveDraftAndLeave,
    onClickCancel,
    onError,
  } = useModalSaveDraft('step2');

  const stateStep2 = useSelector(
    (state: ApplicationState) => state.openClaim.step.step2,
  );

  const [stateSchema, setStateSchema] = useState<any>(schema);

  const { control, handleSubmit } = useForm({
    resolver: yupResolver(stateSchema),
    defaultValues: stateStep2,
  });

  const watchFields = useWatch({
    control,
    name: ['occurrenceDescription', 'occurrenceDate', 'estimateLoss'],
  });

  useEffect(() => {
    if (openModal) {
      setStateSchema(schemaDraft);
    }
  }, [stateStep2, openModal]);

  return (
    <Wrapper>
      <form onSubmit={handleSubmit(onClickForward)}>
        <Label>
          Descreva a ocorrência{' '}
          <span>
            <span>*</span> Campos obrigatórios para abertura de sinistro
          </span>
        </Label>
        <InputTextAreaForm
          label="Descrição da ocorrência:"
          id="1"
          control={control}
          name="occurrenceDescription"
          maxLength={700}
          required
        />
        <RowInput>
          <ColInput>
            <InputForm
              label="Data da Ocorrência:"
              id="2"
              control={control}
              type="text"
              mask="xx/xx/xxxx"
              name="occurrenceDate"
              placeholder="dd/mm/aaaa"
              maxLength={10}
              required
            />
          </ColInput>
          <ColInput>
            <InputForm
              label="Prejuízo Estimado:"
              id="3"
              control={control}
              name="estimateLoss"
              placeholder="R$ 000,00"
              required
              mask={{
                type: 'number',
                style: 'currency',
              }}
            />
          </ColInput>
        </RowInput>
        <ButtonContainer
          onClickForward={handleSubmit(onClickForward)}
          onClickCancel={onClickCancel}
          disabled={!Object.values(watchFields).every(v => v)}
        />
      </form>
      <ModalSaveDraft
        stateModal={stateModal}
        setStateModal={setStateModal}
        isOpen={openModal}
        setIsOpen={setOpenModal}
        handleSubmit={handleSubmit(saveDraftAndLeave, onError)}
      />
    </Wrapper>
  );
};
